export const SUPPORT_EMAIL = process.env.VUE_APP_SUPPORT_EMAIL || 'help@huntica.works';
export const CONFIDENTIAL_URL = (process.env.VUE_APP_FRONT_URL ? `${process.env.VUE_APP_FRONT_URL}/confidential` : 'https://app.huntica.works/confidential');
export const RULES_URL = (process.env.VUE_APP_FRONT_URL ? `${process.env.VUE_APP_FRONT_URL}/rules` : 'https://app.huntica.works/rules');

const frontUrl = process.env.VUE_APP_FRONT_URL || '';
const domain = frontUrl.replace(/^https?:\/\//, '').split('/')[0] || 'huntica.works';
export const APP_DOMAIN = domain;
export const HOME_DOMAIN = domain.replace(/^app\./, '');

const domainParts = domain.split('.');
const appName = domainParts.length >= 2
  ? domainParts.slice(-2).map(part => part.charAt(0).toUpperCase() + part.slice(1)).join('.')
  : 'Huntica.works';
export const APP_NAME = appName;

export const getDomainPrefix = () => {
  let urlToCheck = frontUrl;

  if (!urlToCheck && typeof window !== 'undefined' && window.location) {
    urlToCheck = window.location.hostname;
  }

  if (urlToCheck.includes('.works')) {
    return 'works';
  }
  if (urlToCheck.includes('.online')) {
    return 'online';
  }
  return 'ru';
};
